import { useQuery } from '@tanstack/react-query';
import api from '../api/client';
import { Estabelecimento } from '../types';

export const useEstabelecimento = (estabelecimentoId?: number) => {
  return useQuery({
    queryKey: ['estabelecimento', estabelecimentoId],
    queryFn: async () => {
      if (!estabelecimentoId) {
        return null;
      }
      const response = await api.get<Estabelecimento>(`/estabelecimentos/${estabelecimentoId}`);
      return response.data;
    },
    enabled: !!estabelecimentoId,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};
